export default __webpack_public_path__ + "static/media/din-pro--bold.35e0d463.woff";